<template>
    <div class="content_box mobile_content">
        <div class="content create-order">
            <el-form :line="true" :model="orderData" :rules="formRule" ref="formRule" :label-width="$store.state.type == 'pc' ? '140px' : '100px'"
                class="form-inline">
                <div class="top">
                    <span class="title">工单信息</span>
                    <span class="tip">带*号字段为必填项</span>
                </div>
                <el-form-item class="block" label="外部工单号：">
                    <el-input v-model="orderData.work_idout" maxlength="32" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item class="block" label="工单标题：" prop="work_title">
                    <el-input v-model="orderData.work_title" maxlength="50" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item class="block" label="工单描述：" prop="work_desc">
                    <el-input type="textarea" v-model="orderData.work_desc" rows="6" maxlength="300" show-word-limit
                        placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item class="block" label="附件：">
                    <upload ref="create_upload" path="order/create/" @fileChange="fileChange"></upload>
                </el-form-item>
                <el-form-item class="item-1" label="工单优先级：" prop="priority">
                    <el-radio v-model="orderData.priority" :label="1">低</el-radio>
                    <el-radio v-model="orderData.priority" :label="2">一般</el-radio>
                    <el-radio v-model="orderData.priority" :label="3">紧急</el-radio>
                </el-form-item>
                <el-form-item class="item-1" label="工单来源：" prop="work_source">
                    <el-select v-model="orderData.work_source" placeholder="请选择">
                        <el-option :label="item" :value="item" v-for="item in workSource" :key="item + '135'">
                        </el-option>
                    </el-select>
                </el-form-item>
                <br>
                <el-form-item class="item-1" label="产品分类：">
                    <el-select v-model="orderData.product_id" clearable filterable placeholder="请选择">
                        <el-option :label="item.product_name" :value="item.product_id" v-for="item in product"
                            :key="item.product_id + '123'"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item class="item-1" label="产品型号：" prop="product_type">
                    <el-select v-model="orderData.product_type" clearable placeholder="请先选择产品分类">
                        <el-option :label="item" :value="item" v-for="item in product_types" :key="item + '321'">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item class="item-1" label="产品SN号：">
                    <el-input v-model="orderData.product_sn" maxlength="32" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="集尘宝编号：" v-show="findHas(orderData.product_id, product)">
                    <el-input v-model="orderData.jcb_num" maxlength="32" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item class="item-1" label="销售渠道：">
                    <el-select v-model="orderData.sell_channel" clearable filterable allow-create placeholder="请先选择或输入">
                        <el-option-group
                            v-for="group in salesChannels"
                            :key="group.label"
                            :label="group.label">
                            <el-option
                                v-for="item in group.options"
                                :key="item"
                                :label="item"
                                :value="item">
                            </el-option>
                        </el-option-group>
                    </el-select>
                </el-form-item> 
                <el-form-item class="item-1" label="销售订单号：">
                    <el-input  v-model="orderData.sell_num" maxlength="32" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item class="item-1" label="订单日期：">
                    <el-date-picker
                        v-model="orderData.sell_time"
                        type="date"
                        value-format="timestamp"
                        :editable="true"
                        placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
                <br>
                <el-form-item class="item-2" label="问题分类：">
                    <el-cascader v-model="orderData.cate_ids" :options="cate" :key='cascaderId' filterable clearable
                        placeholder="请先选择产品分类"
                        v-if="$store.state.type == 'pc'"
                        :props="{ expandTrigger: 'click', children: 'next', label: 'cate_name', value: 'cate_id' }">
                    </el-cascader>
                    <div class="cascader_box" v-else>
                        <van-field
                        v-model="cascaderLabel"
                        is-link
                        readonly
                        placeholder="请先选择产品分类"
                        @click="cascaderShow = true"
                        />
                        <van-popup v-model="cascaderShow" round position="bottom">
                            <van-cascader
                                v-model="cascaderValue"
                                title="请先选择产品分类"
                                :options="cate"
                                :fieldNames="{text: 'cate_name', children: 'next', value: 'cate_id'}"
                                @close="cascaderShow = false"
                                @finish="cascaderFinish"
                            />
                        </van-popup>
                    </div>
                </el-form-item>
                <el-form-item class="item-1" label="问题责任方：">
                    <el-select v-model="orderData.problem_source" clearable placeholder="请先选择产品分类">
                        <el-option :label="item" :value="item" v-for="item in source" :key="item + '456'"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="工单受理人：" prop="handler_id">
                    <el-select v-model="orderData.handler_id" filterable placeholder="请选择">
                        <el-option :label="item.user_name" :value="item.user_id" v-for="item in user"
                            :key="item.user_id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <div class="top">
                    <span class="title">客户信息</span>
                </div>
                <el-form-item class="item-1" label="国家/地区：">
                    <el-select v-model="orderData.region" filterable clearable placeholder="请选择">
                        <el-option :label="item.chinese" :value="item.chinese" v-for="(item,i) in country"
                            :key="i + '142'"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item class="item-1 label-wrap" label="客户注册邮箱/手机号：">
                    <el-input v-model="orderData.email_phone" maxlength="32" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item>
                    <div class="btn">
                        <div class="button" @click="createOrder">
                            <span>提交</span>
                        </div>
                    </div>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>
<script>
import upload from '../../../components/file/upload'
export default ({
    name: 'create-order',
    data() {
        return {
            orderData: {
                priority: 2,
                product_type: '',
                product_id: '',
                problem_source: '',
                cate_ids: [],
                file_list: []
            },
            product: [],
            cate: [],
            source: [],
            workSource: [],
            product_types: [],
            salesChannels: [],
            cascaderId: 1,
            cascaderShow: false,
            cascaderValue: '',
            cascaderLabel: '',
            formRule: {
                work_title: [this.requiredRule('请输入工单标题')],
                work_desc: [this.requiredRule('请输入工单描述')],
                priority: [this.requiredRule('请选择优先级')],
                work_source: [this.requiredRule('请选择工单来源')],
                product_id: [this.requiredRule('请选择产品分类')],
                handler_id: [this.requiredRule('请选择受理人')]
            },
            country: [],
            user: [],
            feedback_id: '',
            fbInfo: [],
        }
    },
    components: {
        upload
    },
    watch: {
        'orderData.product_id': function (nId) {
            ++this.cascaderId;
            this.orderData.cate_ids = [];
            this.orderData.product_type = '';
            this.orderData.problem_source = '';
            if (nId) {
                this.getCate(nId);
                this.getProductData(nId);
            } else {  //全部分类
                this.source = [];
            }

        }
    },
    created() {
        this.getWorkSource();
        this.getCountry();
        this.getUser();
        this.getSellChannel();
    },
    activated() {
        this.getProductCate();
    },
    methods: {
        findHas(id, list) {
            for (let i = 0; i < list.length; i++) {
                if (list[i].product_id == id) {
                    return list[i].product_name.search('扫地机器人') == -1 ? false : true;
                }
            }
        },
        getUser() {
            this.api.getUser({order_rule: 'work-order'}).then(data => {
                this.user = data.data.userList;
            })
        },
        getCountry() {
            this.api.getCountry({}).then(data => {
                this.country = data.data.country;
            })
        },
        getProductCate() {
            this.api.getProductCate({}).then(data => {
                this.product = data.data.productCateInfos;
                if (this.orderData.product_id) {
                    ++this.cascaderId;
                    this.getCate(this.orderData.product_id);
                    this.getProductData(this.orderData.product_id);
                }
                if (this.$route.query.feedback_id && this.feedback_id != this.$route.query.feedback_id) {
                    this.feedback_id = this.$route.query.feedback_id;
                    this.getFbInfo();
                }
                if(this.feedback_id && this.feedback_id != this.$route.query.feedback_id){
                    this.orderData = {
                        priority: 2,
                        product_type: '',
                        product_id: '',
                        problem_source: '',
                        cate_ids: [],
                        file_list: []
                    };
                }
            })
        },
        getCate(id) {  //需要过滤掉next为空的属性
            this.api.getCate({ product_id: id }).then(data => {
                this.cate = this.filterCate(data.data.cateInfos);
            })
        },
        filterCate(cate) {
            for (let i = 0; i < cate.length; i++) {
                if (cate[i].next && cate[i].next.length > 0) {
                    cate[i].next = this.filterCate(cate[i].next)
                } else {
                    delete cate[i].next;
                }
            }
            return cate;
        },
        getProductData(id) {
            for (let i = 0; i < this.product.length; i++) {
                if (this.product[i].product_id == id) {
                    this.source = this.product[i].problemSource;
                    this.product_types = this.product[i].productTypes;
                    break;
                }
            }
        },
        getWorkSource() {
            this.api.getWorkSource({}).then(data => {
                this.workSource = data.data.work_sources;
            });
        },
        getSellChannel() {
            this.api.getSellChannel({}).then(data => {
                this.salesChannels = data.data.sellObj;
            })
        },
        cascaderFinish({selectedOptions}) {
            this.cascaderShow = false;
            this.cascaderLabel = selectedOptions.map((option) => option.cate_name).join('/');
            this.orderData.cate_ids = selectedOptions.map((option) => option.cate_id);
        },
        beforeUpload(file) {
            this.fileSize += file.size;
            if (this.fileSize / 1024 / 1024 > 300) {
                this.$message.warning('总大小不得超过300M！');
                this.fileSize -= file.size;
                return false;
            }
            this.fileList.push(file);
        },
        uploadChange(file, fileList) {
            this.fileList.forEach((item, i) => {
                if (item.uid == fileList.uid) {
                    this.$set(this.fileList, i, fileList);
                }
            })
        },
        exceed() {
            this.$message.warning('附件数量上限10个！')
        },
        fileChange(file, type, i) {
            if(type == 'upload') {
                this.orderData.file_list.push(file);
            }else{
                this.orderData.file_list.splice(i, 1);
            }
            
        },
        createOrder() {
            this.$refs.formRule.validate(v => {
                if (v) {
                    this.api.createWork(this.orderData).then(data => {
                        this.$message.success('工单创建成功！');
                        this.orderData = {
                            priority: 2,
                            product_type: '',
                            product_id: '',
                            problem_source: '',
                            cate_ids: [],
                            file_list: []
                        };
                        this.cate = [];
                        this.source = [];
                        this.product_types = [];
                        this.$refs.create_upload.init();
                        this.$router.push({ name: 'order-manage', query: { state: 'work_sum' }, params: { reload: 'true' } });
                        this.$store.commit('delTags', 'create-order');
                    })
                }
            });
        },
        getFbInfo() {
            this.api.getFbList({ id: this.$route.query.feedback_id }).then(data => {
                var fbInfo = data.data.feedback_list[0];
                if (fbInfo.files != '') {
                    this.getFilesList(fbInfo.id)
                }
                this.orderData = {
                    feedback_id: parseInt(this.$route.query.feedback_id),
                    work_idout: this.$route.query.region + '_appfb_' + fbInfo.id,
                    work_title: fbInfo.title,
                    work_desc: fbInfo.text,
                    priority: 2,
                    work_source: 'APP用户反馈',
                    product_id: 1,
                    product_sn: fbInfo.SN,
                    problem_source: '',
                    product_type: ''
                };
                this.$nextTick(() => {
                    this.orderData.product_type = fbInfo.product;
                })
                this.country.forEach(country => {
                    var code = '+' + fbInfo.area;
                    if (country.code == code) {
                        this.orderData.region = country.chinese;
                        return;
                    }
                });
            })
        },
        getFilesList(id) {
            this.api.getFbFiles({ feedback_id: id }).then(data => {
                this.fileList = data.data.file_addr;
                // return data.data
            })
        }
    }
})
</script>
<style lang="less" scoped>
@formInputW: 605px;

.create-order {
    /deep/ .el-form {
        padding: 0 10%;
        font-size: 0; //解决inline-block间隙问题
        .top {
            margin-bottom: 20px;
            margin-left: -12%;

            .title {
                font-size: 16px;
                font-weight: 600;
            }

            .tip {
                font-size: 14px;
                color: rgba(0, 0, 0, .6);
                padding-left: 12px;
            }
        }

        .files_box {
            .flexLayout(flex-start, flex-start);

            .file_item {
                position: relative;
                width: 150px;
                height: 40px;
                padding: 10px;
                margin: 10px 10px 10px 0;
                border-radius: 3px;
                border: 1px solid #ddd;
                line-height: 1.3;
                cursor: pointer;
                .flexLayout(flex-start);
                flex-wrap: nowrap;

                .download_btn {
                    position: absolute;
                    bottom: 5px;
                    right: 5px;
                    width: 20px;
                    height: 20px;
                    font-size: 18px;
                    color: @colorBlue;
                    // display: none;
                }
            }

            .file {
                width: 40px;
                height: 50px;
                margin-right: 10px;

                img {
                    width: 100%;
                    height: 100%;
                    object-fit: contain;
                }
            }

            .file_msg {
                width: 100px;
                overflow: hidden;

                p {
                    margin: 5px 0;

                    &.file_name {
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }

                    &.file_size {
                        color: #999;
                        font-size: 12px;
                    }
                }
            }

        }

        .el-form-item {
            display: inline-block;
            width: 100%;
            font-size: 16px;

            &.item-1 {
                width: 33.3%;
            }

            &.item-2 {
                width: 66.6%;
            }

            .el-cascader {
                width: 100%;
            }

            .el-form-item__label {
                padding-left: 20px;
            }

            @media (max-width: 1665px) {

                &.item-1,
                &.item-2 {
                    width: 50%;
                }
            }
        }
        @media (max-width: 768px) {
            padding: 0;
            .top{
                margin: 0 0 20px;
            }
            .el-form-item {
                font-size: 12px;
                &.item-1, &.item-2{
                    width: 100;
                }
                .el-cascader {
                    width: 100%;
                }
                .el-form-item__label {
                    padding-left: 0;
                    font-size: 12px;
                }

                @media (max-width: 1665px) {
                    &.item-1,
                    &.item-2 {
                        width: 100%;
                    }
                }
        }
        }
    }
}

.view_area {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    z-index: 3000;

    .view_box {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 500px;
        height: 500px;

        img,
        video {
            width: 100%;
        }

        .close {
            position: absolute;
            top: -22px;
            right: -18px;
            font-size: 32px;
            cursor: pointer;
            color: #9aa;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/view/order/order-manage/create-order.vue